// Styles for ModalPageContent go here.
import styled from 'styled-components';

export const StyledModalPageContent = styled.div``;
